// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select} from '@ngrx/store';
import { Observable, filter, map, take } from 'rxjs';
import { authPortalUserState  } from '../app-states/app.state';

@Injectable({
  providedIn: 'root'
})
export class SelectedTenantGuard  {

  constructor(private store: Store, private router: Router) {

  }

  canActivateChild(): Observable<boolean> {
    return this.store.pipe(select(authPortalUserState)).pipe(
      filter(authUserState => authUserState.status === 'loaded'),
      take(1),
      map(authUserState => {
      
        if (authUserState.currentTenantId && authUserState.authUser) {
          const tenantProfile = authUserState.authUser.getTenantProfile(authUserState.currentTenantId);
          if (!tenantProfile) {
            this.router.navigate(['userSettings'])
            return false;
          }
          if (tenantProfile.suspendedAt) {
            this.router.navigate(['suspendedTenant'])
            return false
          }
          return true;
        } else {
          this.router.navigate(['getstarted'])
          return false;
        }
      })
    )
  }

}
